import { useNavigate } from 'react-router-dom';
import { sanitizeRedirectUrl } from './sanitize-redirect-url';

export const useSafeNavigate = () => {
  const navigate = useNavigate();
  return (redirectUrl: string | undefined, fallbackUrl: string = '/') =>
    navigate(sanitizeRedirectUrl(redirectUrl, fallbackUrl));
};
